import { fetchClient, HttpClient } from '@cld/session-service';
import { API_BASE_URL } from '@cld/application-wrapper-common';
import Zod from 'zod';

const accountInfoSchema = Zod.object({
  max_customers: Zod.number(),
  num_customers: Zod.number(),
  max_users: Zod.number(),
  new_billing_system: Zod.boolean(),
});
export const createFetchAccountInfo = (httpClient: HttpClient) => () => {
  return httpClient(`${API_BASE_URL}/account`).then((res) => accountInfoSchema.parse(res));
};

// istanbul ignore next
export const fetchAccountInfo = createFetchAccountInfo(fetchClient);
